module.exports = __webpack_public_path__ + "img/img-55.7ffdb953.png";